// ─────────────────────────────────────────────────────────────
// SortBeat Daily — Audio Synchronisation
// Pure functions for beat position inference and on-beat detection.
// No React imports — safe to unit test without a device.
// ─────────────────────────────────────────────────────────────

/**
 * Beat duration in milliseconds for a given BPM.
 */
export function beatDurationMs(bpm: number): number {
  'worklet';
  return 60_000 / bpm;
}

/**
 * Returns a 0.0–1.0 phase value indicating where we are within the current beat.
 * 0.0 = exactly on a beat boundary, 0.5 = halfway between beats.
 *
 * NOTE: expo-av `getStatusAsync` has ±30ms jitter. The caller should smooth
 * positionMs before passing it here (e.g. via a running average).
 */
export function inferBeatPhase(positionMs: number, bpm: number): number {
  'worklet';
  const beatMs = beatDurationMs(bpm);
  return (positionMs % beatMs) / beatMs;
}

/**
 * Returns true when the given position is within `windowMs` of a beat boundary.
 * Default window of 50ms gives a ±50ms tolerance either side of the beat.
 */
export function isOnBeat(positionMs: number, bpm: number, windowMs = 50): boolean {
  'worklet';
  const beatMs = beatDurationMs(bpm);
  const phase = positionMs % beatMs;
  return phase < windowMs || phase > beatMs - windowMs;
}

/**
 * Returns the position of the nearest upcoming beat boundary in ms.
 * Useful for scheduling effects to snap to the next beat.
 */
export function msToNextBeat(positionMs: number, bpm: number): number {
  'worklet';
  const beatMs = beatDurationMs(bpm);
  const phase = positionMs % beatMs;
  return beatMs - phase;
}
